/**
 * Frontend API helper — posts to our FastAPI backend which forwards
 * submissions to the configured GoHighLevel inbound webhook.
 *
 * All GHL webhook URLs live on the backend .env only — the frontend
 * only knows internal endpoints (see /api/ghl/*).
 */
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
  timeout: 15000,
});

// Form key -> endpoint mapping (mirrors backend/server.py FORM_WEBHOOKS)
export const FORMS = {
  visit: "/ghl/visit",
  prayer: "/ghl/prayer",
  volunteer: "/ghl/volunteer",
  event: "/ghl/event",
  newsletter: "/ghl/newsletter",
  contact: "/ghl/contact",
  wcep: "/ghl/wcep",
};

export async function submitForm(formKey, data) {
  const path = FORMS[formKey];
  if (!path) throw new Error(`Unknown form key: ${formKey}`);
  const { data: result } = await client.post(path, data);
  return result;
}

export async function fetchSermons(limit = 4) {
  const { data } = await client.get(`/sermons`, { params: { limit } });
  return data?.items ?? [];
}
